var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAadi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.65 59.83C119.65 75.6979 113.346 90.9159 102.126 102.136C90.9059 113.357 75.6879 119.66 59.82 119.66C43.9538 119.657 28.7384 113.353 17.5203 102.133C6.30213 90.9127 3.12289e-06 75.6962 3.34451e-06 59.83C-0.00262405 51.9731 1.5428 44.1927 4.54798 36.9333C7.55317 29.6738 11.9592 23.0776 17.5144 17.5215C23.0696 11.9654 29.6651 7.5582 36.924 4.55181C44.183 1.54541 51.9631 -0.00131073 59.82 3.34535e-06C67.6777 -0.00262466 75.459 1.54313 82.7191 4.54894C89.9792 7.55475 96.5758 11.9617 102.132 17.5179C107.688 23.0742 112.095 29.6708 115.101 36.9309C118.107 44.191 119.653 51.9723 119.65 59.83V59.83Z",
    fill: "#95C8D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.64 57.83C110.64 64.5046 109.325 71.1139 106.771 77.2803C104.216 83.4467 100.472 89.0495 95.7516 93.7687C91.0315 98.4879 85.428 102.231 79.261 104.784C73.0941 107.338 66.4846 108.651 59.81 108.65C53.1367 108.65 46.5288 107.335 40.3636 104.781C34.1983 102.227 28.5966 98.4838 23.8784 93.7646C19.1601 89.0454 15.4177 83.4429 12.8648 77.2772C10.312 71.1115 8.99869 64.5033 9 57.83C8.99869 51.1562 10.3119 44.5475 12.8646 38.3813C15.4173 32.215 19.1596 26.6119 23.8778 21.8919C28.5959 17.1719 34.1975 13.4274 40.3628 10.8723C46.5281 8.31711 53.1362 7.00131 59.81 7C73.291 7 86.2198 12.3553 95.7522 21.8878C105.285 31.4202 110.64 44.349 110.64 57.83V57.83Z",
    fill: "url(#paint0_linear_2322:4536)",
    fillOpacity: 0.58
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M104.75 59.83C104.75 65.7233 103.589 71.5588 101.334 77.0033C99.078 82.4478 95.772 87.3947 91.6043 91.5614C87.4367 95.7281 82.4891 99.033 77.0441 101.287C71.599 103.542 65.7633 104.701 59.87 104.7C47.9697 104.7 36.5569 99.9726 28.1421 91.5579C19.7274 83.1431 15 71.7303 15 59.83C15.0106 47.9367 19.7426 36.5341 28.1562 28.128C36.5699 19.7219 47.9767 15 59.87 15C71.7651 14.9973 83.1744 19.718 91.5902 28.1244C100.006 36.5308 104.739 47.9349 104.75 59.83Z",
    fill: "url(#paint1_linear_2322:4536)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M101.172 60.082C101.169 71.5093 96.6286 82.4679 88.5483 90.5483C80.4679 98.6286 69.5093 103.169 58.082 103.172C46.6555 103.169 35.698 98.6283 27.6192 90.5477C19.5404 82.467 15.002 71.5084 15.002 60.082C15.002 48.6564 19.5407 37.6989 27.6198 29.6198C35.6989 21.5407 46.6564 17.002 58.082 17.002C69.5084 17.002 80.467 21.5404 88.5476 29.6192C96.6283 37.698 101.169 48.6555 101.172 60.082Z",
    fill: "url(#paint2_radial_2322:4536)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.172 58.082C103.169 69.5093 98.6286 80.4679 90.5483 88.5483C82.4679 96.6286 71.5093 101.169 60.082 101.172C48.6555 101.169 37.698 96.6283 29.6192 88.5477C21.5404 80.467 17.002 69.5084 17.002 58.082C17.002 46.6564 21.5407 35.6989 29.6198 27.6198C37.6989 19.5407 48.6564 15.002 60.082 15.002C71.5084 15.002 82.467 19.5404 90.5476 27.6192C98.6283 35.698 103.169 46.6555 103.172 58.082Z",
    fill: "#89E3FF",
    style: {
      mixBlendMode: "screen"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8198 9C53.146 9.00131 46.5378 10.3171 40.3726 12.8723C34.2073 15.4274 28.6057 19.1719 23.8875 23.8919C19.1694 28.6119 15.4271 34.215 12.8744 40.3813C10.3217 46.5475 9.00845 53.1562 9.00977 59.83C9.00845 66.5033 10.3217 73.1115 12.8746 79.2772C15.4274 85.4429 19.1699 91.0454 23.8881 95.7646C28.6064 100.484 34.2081 104.227 40.3733 106.781C46.5385 109.335 53.1465 110.65 59.8198 110.65C66.4944 110.651 73.1039 109.338 79.2708 106.784C85.4377 104.231 91.0413 100.488 95.7614 95.7687C100.482 91.0495 104.226 85.4467 106.78 79.2803C109.335 73.1139 110.65 66.5046 110.65 59.83C110.65 46.349 105.294 33.4202 95.762 23.8878C86.2295 14.3553 73.3007 9 59.8198 9ZM59.8198 109.74C46.5901 109.716 33.9091 104.45 24.5543 95.0954C15.1996 85.7406 9.93356 73.0596 9.90977 59.83C9.93092 46.5986 15.1957 33.9151 24.5508 24.5581C33.9059 15.2012 46.5884 9.9338 59.8198 9.91C73.0546 9.92852 85.7422 15.1936 95.1016 24.5511C104.461 33.9086 109.729 46.5952 109.75 59.83C109.729 73.0648 104.461 85.7514 95.1016 95.1089C85.7422 104.466 73.0546 109.731 59.8198 109.75V109.74Z",
    fill: "#B4B4B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8192 15C47.9259 15 36.5191 19.7219 28.1055 28.128C19.6919 36.5341 14.9598 47.9367 14.9492 59.83C14.9492 71.7303 19.6766 83.1431 28.0913 91.5579C36.5061 99.9726 47.919 104.7 59.8192 104.7C65.7125 104.701 71.5483 103.542 76.9933 101.287C82.4383 99.033 87.3859 95.7281 91.5536 91.5614C95.7212 87.3947 99.0272 82.4478 101.283 77.0033C103.538 71.5588 104.699 65.7233 104.699 59.83C104.689 47.9349 99.9552 36.5308 91.5394 28.1244C83.1237 19.718 71.7143 14.9973 59.8192 15ZM59.8192 103.85C48.1497 103.85 36.9581 99.2143 28.7065 90.9627C20.4549 82.7111 15.8192 71.5195 15.8192 59.85C15.8192 48.1805 20.4549 36.9889 28.7065 28.7373C36.9581 20.4857 48.1497 15.85 59.8192 15.85C65.5974 15.85 71.319 16.9881 76.6573 19.1993C81.9956 21.4105 86.8461 24.6515 90.9319 28.7373C95.0177 32.8231 98.2587 37.6736 100.47 43.0119C102.681 48.3503 103.819 54.0718 103.819 59.85C103.811 71.5143 99.1721 82.6982 90.9213 90.9433C82.6706 99.1884 71.4836 103.82 59.8192 103.82V103.85Z",
    fill: "url(#paint3_linear_2322:4536)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.82 3.34535e-06C51.9631 -0.00131073 44.183 1.54541 36.924 4.55181C29.6651 7.5582 23.0696 11.9654 17.5144 17.5215C11.9592 23.0776 7.55317 29.6738 4.54798 36.9333C1.5428 44.1927 -0.00262405 51.9731 3.34451e-06 59.83C3.12289e-06 75.6962 6.30213 90.9127 17.5203 102.133C28.7384 113.353 43.9538 119.657 59.82 119.66C67.677 119.66 75.457 118.112 82.716 115.106C89.9749 112.099 96.5705 107.692 102.126 102.136C107.682 96.5805 112.089 89.9849 115.096 82.726C118.102 75.467 119.65 67.687 119.65 59.83C119.653 51.9723 118.107 44.191 115.101 36.9309C112.095 29.6708 107.688 23.0742 102.132 17.5179C96.5758 11.9617 89.9792 7.55475 82.7191 4.54894C75.459 1.54313 67.6777 -0.00262466 59.82 3.34535e-06ZM59.82 118.76C44.1965 118.741 29.2182 112.527 18.1707 101.479C7.12316 90.4318 0.908528 75.4535 0.890003 59.83C0.905882 44.2048 7.11935 29.2239 18.1671 18.1742C29.2149 7.12453 44.1948 0.908533 59.82 0.890003C75.447 0.905887 90.4294 7.12072 101.479 18.1707C112.529 29.2206 118.744 44.203 118.76 59.83C118.744 75.457 112.529 90.4394 101.479 101.489C90.4294 112.539 75.447 118.754 59.82 118.77V118.76Z",
    fill: "url(#paint4_linear_2322:4536)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M14.5894 34.8001C19.0626 26.7222 25.6157 19.9883 33.5689 15.2969C41.5221 10.6055 50.5856 8.12758 59.8194 8.12007C73.5289 8.13595 86.6723 13.5891 96.3663 23.2831C106.06 32.9772 111.514 46.1206 111.529 59.8301C111.529 62.993 111.241 66.1493 110.669 69.2601L115.389 69.9301L117.159 70.1801C117.758 66.7626 118.059 63.2996 118.059 59.8301C118.061 52.1811 116.555 44.6067 113.629 37.5395C110.703 30.4724 106.413 24.0509 101.005 18.6417C95.5966 13.2326 89.1758 8.94174 82.1092 6.01428C75.0425 3.08682 67.4684 1.58008 59.8194 1.58008C49.5903 1.57812 39.5412 4.2703 30.6831 9.38574C21.825 14.5012 14.4704 21.8594 9.35938 30.7201C11.0394 32.1501 12.7894 33.5101 14.5894 34.8001Z",
    fill: "url(#paint5_linear_2322:4536)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M100.16 92.1601C95.3162 98.2044 89.1764 103.083 82.1941 106.436C75.2117 109.788 67.5653 111.529 59.8198 111.53C48.6429 111.512 37.7714 107.882 28.8271 101.179C19.8828 94.4768 13.3452 85.0623 10.1898 74.3401C7.70977 73.4501 5.23977 72.5401 2.75977 71.6001C5.47405 84.7283 12.6313 96.5193 23.0251 104.986C33.419 113.453 46.4139 118.077 59.8198 118.08C69.3599 118.081 78.754 115.737 87.1761 111.256C95.5982 106.775 102.79 100.293 108.12 92.3801C105.47 92.3401 102.81 92.2601 100.16 92.1601Z",
    fill: "url(#paint6_linear_2322:4536)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.159 70.1798C126.589 6.99979 41.8394 -21.6402 9.35938 30.7198C40.5894 -25.9502 129.949 6.6498 117.159 70.1798Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.159 70.1798C126.589 6.99979 41.8394 -21.6402 9.35938 30.7198C40.5894 -25.9502 129.949 6.6498 117.159 70.1798Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M108.75 68.0801C116.65 13.5201 45.4201 -11.1899 18.1201 34.0201C44.3401 -14.8999 119.51 13.2401 108.75 68.0801Z",
    fill: "url(#paint7_linear_2322:4536)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.48 66.4298C109.39 19.9498 47.0797 -1.10024 23.1797 37.4298C46.1397 -4.26024 111.9 19.7098 102.48 66.4298Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.91 102.81C70.91 126.81 37.74 120.64 15.75 96.8099C1.11999 80.9199 -3.25001 55.9899 8.13999 32.6099C-23.22 89.1499 51.96 147.47 98.91 102.81Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M92.6603 96.8C50.6903 132.55 -8.1397 85.41 15.5903 38.21C-11.8497 86.49 51.9703 135.12 92.6603 96.8Z",
    fill: "url(#paint8_linear_2322:4536)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M89.3002 91C55.8002 124 2.08016 86 19.1602 44C-1.01984 87.14 57.0702 126.14 89.3002 91Z",
    fill: "url(#paint9_linear_2322:4536)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2322:4536",
    x1: 94.5015,
    y1: 13.502,
    x2: 23.0015,
    y2: 100.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AA0C5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2322:4536",
    x1: 30.16,
    y1: 25.74,
    x2: 94.64,
    y2: 99.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#6E6E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2322:4536",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.402 30.962) scale(69.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2322:4536",
    x1: 8665.05,
    y1: -11420.9,
    x2: 12288.5,
    y2: -3369.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2322:4536",
    x1: 8773.93,
    y1: -16806.2,
    x2: 18518.1,
    y2: -3650.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2322:4536",
    x1: 82.2994,
    y1: 4.27008,
    x2: 63.6794,
    y2: 49.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2322:4536",
    x1: 54.9898,
    y1: 93.3901,
    x2: 54.0998,
    y2: 115.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2322:4536",
    x1: 11037.6,
    y1: -5238.87,
    x2: 11833.2,
    y2: -7972.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2322:4536",
    x1: 15834.7,
    y1: -21579.3,
    x2: 13809.1,
    y2: -18870.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2322:4536",
    x1: 9648.4,
    y1: -5198.04,
    x2: 8315.81,
    y2: -3246.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAadi);
export default __webpack_public_path__ + "static/media/aadi.b7067e95ba2d610be73da60294718c1f.svg";
export { ForwardRef as ReactComponent };